import PropTypes from 'prop-types';
import React from 'react';
import core from '@bravissimolabs/website-core';
import { requireAddressLookup } from 'shared/containers/AddressLookupContainer';
import { defineMessages, injectIntl, intlShape } from 'react-intl';
import { reduxForm } from 'redux-form';

import Meta from 'shared/containers/MetaContainer';
import Bandeau from 'brastrap/common/bandeau/Bandeau';
import EditorialContainer from 'brastrap/editorial/editorial-container/EditorialContainer';
import RequestMagazineForm from 'brastrap/common/request-magazine-form/RequestMagazineForm';
import {
  closeMessages,
  apiRequestMagazine,
} from 'shared/actions/request-magazine';
import { formatCountriesForSelect } from 'shared/utils/utils';
import { receiveCountries } from '../../../actions/countries';
import { receivePageContainers } from '../../../actions/editorial';

import validate from './validateForm';

const MAGAZINE_SETTING_GROUP = 'magazine';
const onSubmitPayload = (payload, dispatch) => {
  dispatch(apiRequestMagazine(payload));
};

const messages = defineMessages({
  pageTitle: {
    id: 'magazine-page.title',
    defaultMessage: 'Request A Magazine',
  },
  description: {
    id: 'magazine-page.description',
    defaultMessage:
      'Request our magazine to get a view of our latest lingerie,' +
      ' swimwear and clothing styles delivered to your door. You can also sign up for emails here.',
  },
});

const formName = 'requestMagazineForm';

const MagazinePage = props => (
  <Meta
    title={props.intl.formatMessage(messages.pageTitle)}
    description={props.intl.formatMessage(messages.description)}
  >
    <Bandeau
      title={props.intl.formatMessage(messages.pageTitle)}
      className="c-magazine-page__title"
    />
    {props.headerContainers.length && (
      <EditorialContainer containers={props.headerContainers} />
    )}
    <div className="c-page__main">
      <RequestMagazineForm
        {...props}
        onSubmitPayload={onSubmitPayload}
        namespace={formName}
      />
    </div>
    {props.footerContainers.length && (
      <EditorialContainer containers={props.footerContainers} />
    )}
  </Meta>
);

MagazinePage.propTypes = {
  intl: intlShape,
  isSaving: PropTypes.bool.isRequired,
  countries: PropTypes.array,
  fields: PropTypes.object,
  headerContainers: PropTypes.array,
  footerContainers: PropTypes.array,
};

MagazinePage.populateStore = async store => {
  // TODO: How should this behave outside of the UK??

  const countries = await core.system.system.getCountries();
  store.dispatch(receiveCountries(countries));
  // Get header and footer containers for the page
  const contentApi = core.content.editorial;
  const containers = await contentApi.getWrapperContainers(
    MAGAZINE_SETTING_GROUP
  );
  store.dispatch(receivePageContainers(containers));
};

export default requireAddressLookup(
  injectIntl(
    reduxForm(
      {
        form: formName,
        fields: [
          'details.title',
          'details.firstName',
          'details.lastName',
          'address.search',
          'address.address1',
          'address.address2',
          'address.countryId',
          'address.town',
          'address.region',
          'address.postCode',
          'email',
        ],
        validate,
      },
      state => ({
        // mapStateToProps
        countries: formatCountriesForSelect(state.countries.data),
        initialValues: {
          address: {
            countryId: state.countries.data.find(
              country => country.isoCode === state.app.config.outlet
            ).id,
          },
        },
        isSaving: state.requestMagazineForm.isSaving,
        confirmationMessage: state.requestMagazineForm.confirmationMessage,
        errorMessage: state.requestMagazineForm.errorMessage,
        headerContainers: state.content.headerContainers || [],
        footerContainers: state.content.footerContainers || [],
      }),
      dispatch => ({
        onCloseMessages: () => dispatch(closeMessages()),
      })
    )(MagazinePage)
  ),
  { formName }
);
